import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  GetSingleGuestReviewTemplateResponse,
  GuestReviewTemplate,
} from 'models/automation/Reviews';
import API from 'services/API';

export const GUEST_REVIEW_TEMPLATE_BASE_QUERY_KEY = 'guest-review-template';

type ReactQueryOptions = Omit<
  UseQueryOptions<GuestReviewTemplate>,
  'queryKey' | 'queryFn'
>;

type UseFetchGuestReviewTemplateArgs = ReactQueryOptions & {
  reviewTemplateUid?: string;
};

const useFetchGuestReviewTemplate = ({
  reviewTemplateUid = '',
  enabled = true,
  ...options
}: UseFetchGuestReviewTemplateArgs = {}) => {
  return useAppQuery<GuestReviewTemplate>({
    queryKey: [
      GUEST_REVIEW_TEMPLATE_BASE_QUERY_KEY,
      'detail',
      reviewTemplateUid,
    ],
    queryFn: async () => {
      const response = await API.get<GetSingleGuestReviewTemplateResponse>(
        `/api/internal/predefined-hosts-reviews/${reviewTemplateUid}`,
      );

      return response.data.predefinedHostsReview;
    },
    staleTime: 30000,
    enabled,
    ...(options ?? {}),
  });
};

export default useFetchGuestReviewTemplate;
